module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC4SURBVEhL7ZBBCgIxEATnEZ4WvPseXyR+xoPgH/QufkQU17PR7km7IoLJbhQEUzAk05nuhFil8j2uhYQQWkWZoTlLd6hpOxhk7jycoFlJd6hpW8LMwwmaCS45RL38AmSdsIw8/A7EMWrJQ/ZxtD/wk6mHvkPzvUDwMSucyJMEgS1qi5qjff6WnyK+94Hkz6HcDsnDwZ82qAVqr8wXeKaZRrZ8YNooJwlm17LlA9NF/iScla3yf5jdAMQEorKxX/89AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-metal/light/24.png
// module id = 2248
// module chunks = 2